import React from 'react';

/**
 * Email badge style utility
 * Generates consistent email badge styling for gallery components
 */
export const getEmailBadgeStyle = (isMobile: boolean): React.CSSProperties => ({
  borderRadius: '30px',
  paddingTop: '5px',
  paddingRight: '13px',
  paddingBottom: '5px',
  paddingLeft: '13px',
  height: '30px',
  width: '120px',
  fontFamily: 'Maven Pro',
  fontWeight: 400,
  fontSize: '12px',
  lineHeight: '18px',
  letterSpacing: '0%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',

  ...(isMobile && {
    width: '180px',
    position: 'absolute',
    bottom: '8px',
    left: '8px',
    display: 'block',
  }),
});
